// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function isImage(param) {
  return param.contentType.startsWith("image/");
}

function make(id, key, fileName, contentType) {
  return {
          id: id,
          key: key,
          fileName: fileName,
          contentType: contentType
        };
}

exports.isImage = isImage;
exports.make = make;
/* No side effect */
